const housePricePrediction = {
  fa: {
    header: {
      title: "پیش‌بینی قیمت خانه",
      intro:
        "House Price Prediction یک پروژه یادگیری ماشین برای پیش‌بینی قیمت خانه بر اساس داده‌های واقعی بازار مسکن تهران است که با استفاده از الگوریتم رگرسیون خطی توسعه داده شده است.",
      description: [
        "در این پروژه، فرایند کار تنها به آموزش مدل محدود نشده و مراحل مختلف آماده‌سازی داده نیز مورد توجه قرار گرفته است. داده‌ها ابتدا بررسی و پیش‌پردازش شده و سپس برای آموزش مدل مورد استفاده قرار گرفته‌اند تا تأثیر کیفیت داده بر نتیجه نهایی بهتر درک شود.",

        "یکی از بخش‌های مهم پروژه، پیاده‌سازی رگرسیون خطی به دو روش معادله نرمال و گرادیان نزولی است. همچنین ساختار پروژه به شکلی طراحی شده که پیاده‌سازی رگرسیون خطی بتواند با مجموعه‌داده‌های مختلف نیز مورد استفاده قرار گیرد.",

        "این پروژه علاوه بر پیاده‌سازی مدل، شامل یک Notebook آموزشی برای بررسی و تجسم داده‌ها و درک بهتر مراحل پیش‌پردازش است و امکان اجرای فرایند آموزش از طریق خط فرمان نیز فراهم شده است.",
      ],
      image:
        "https://github.com/F-Yousefi/House_Price_Prediction/raw/main/images/header.png",
    },
    side: {
      Project: "House Price Prediction",
      LiveDemo: "https://github.com/F-Yousefi/House_Price_Prediction",
      Language: "انگلیسی",
      Date: "آبان ۱۴۰۲",
      Technologies:
        "Linear Regression · Gradient Descent · Normal Equation · Data Preprocessing · Data Visualization · Reusable Implementation",
    },
  },

  en: {
    header: {
      title: "House Price Prediction",
      intro:
        "House Price Prediction is a machine learning project for predicting house prices using a real-world Tehran housing dataset and a custom implementation of Linear Regression.",
      description: [
        "The project goes beyond simply training a model by exploring the data preparation pipeline, including dataset visualization and preprocessing. These steps provide a clearer understanding of how the quality and structure of the input data can affect the learning process.",

        "A key part of the project is the implementation of Linear Regression using two different optimization approaches: Normal Equation and Gradient Descent. The implementation is also structured to be reusable with different datasets.",
        "The project includes both a detailed Jupyter Notebook for exploring the data and preprocessing workflow, and a command-line interface for training the model with configurable dataset and optimization options.",
      ],
      image:
        "https://github.com/F-Yousefi/House_Price_Prediction/raw/main/images/header.png",
    },
    side: {
      Project: "House Price Prediction",
      LiveDemo: "https://github.com/F-Yousefi/House_Price_Prediction",
      Language: "English",
      Date: "October 2023",
      Technologies:
        "Linear Regression · Gradient Descent · Normal Equation · Data Preprocessing · Data Visualization · Reusable Implementation",
    },
  },
};

export default housePricePrediction;
